"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleItem = void 0;
var react_1 = __importDefault(require("react"));
var ExpressionToReadable_1 = require("@components/ExpressionToReadable");
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var fromDateUtil_1 = require("@features/ItemLogPage/util/fromDateUtil");
var BlangEditor_1 = require("@/react-app/common/components/BlangEditor");
var getTranslationKey = function (ruleResult) {
    return "itemLog:TABLE.RULE.ACTIONS_RESULT.".concat(ruleResult);
};
function RuleItem(_a) {
    var _b, _c, _d;
    var rule = _a.rule, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, minDate = _a.minDate;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _e = __read(react_1.default.useState(false), 2), isExpanded = _e[0], setIsExpanded = _e[1];
    return (react_1.default.createElement("div", { className: "rules-modal__row" },
        react_1.default.createElement("div", { className: "rules-modal__icon" },
            react_1.default.createElement("span", { className: "item-event-type-icon item-event-type-icon--".concat(rule.result), title: (_b = t(getTranslationKey(rule.result))) !== null && _b !== void 0 ? _b : '' })),
        react_1.default.createElement("div", { className: "rules-modal__details" },
            react_1.default.createElement("a", { href: angularJsDependencies.href('app.assignment.automation.filterView', {
                    domain: domain,
                    filterId: rule.id,
                    from: (0, fromDateUtil_1.maxFromDate)(rule.lastModifiedTime, minDate),
                }), className: "rules-modal__link-to-rule" }, rule.name), (_d = (_c = rule === null || rule === void 0 ? void 0 : rule.blangResult) === null || _c === void 0 ? void 0 : _c.expressions) === null || _d === void 0 ? void 0 :
            _d.map(function (expression, index) { return (react_1.default.createElement(ExpressionToReadable_1.ExpressionToReadable, { key: index, expression: expression, angularJsDependencies: angularJsDependencies, domain: domain })); }),
            isExpanded && (react_1.default.createElement("div", { className: "rules-modal__code-mirror" },
                react_1.default.createElement(BlangEditor_1.BlangEditor, { editable: false, value: rule.rule })))),
        react_1.default.createElement("i", { onClick: function () { return setIsExpanded(!isExpanded); }, className: (0, clsx_1.default)({
                'expression-toggle-btn': true,
                'implioicons-arrow-2-up': isExpanded,
                'implioicons-arrow-2-down': !isExpanded,
            }) })));
}
exports.RuleItem = RuleItem;
